import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import PageHeader from '@/components/ui/PageHeader';
import Bottle from '@/components/ui/Bottle';
import { COLLECTIONS, PRODUCTS } from '@/data/products';

export default function Collections() {
  return (
    <div data-testid="page-collections">
      <PageHeader
        eyebrow="Curated"
        title="Collections,"
        accent="crafted to fit your day."
        description="From the morning ritual to midnight indulgence — discover sets of bottles that move with your moments."
      />

      <section className="container-x py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {COLLECTIONS.map((col) => {
            const bottles = col.productIds
              .map((id) => PRODUCTS.find((p) => p.id === id))
              .filter(Boolean)
              .slice(0, 3);
            return (
              <Link
                to={`/shop`}
                key={col.slug}
                data-testid={`collection-${col.slug}`}
                className="group relative glass-card rounded-3xl p-8 lg:p-10 overflow-hidden hover:border-gold/30 transition-all min-h-[360px] flex flex-col justify-between"
              >
                <div
                  className="absolute -right-20 -top-20 w-96 h-96 rounded-full blur-3xl opacity-50 pointer-events-none"
                  style={{ background: `${col.tone}33` }}
                />
                <div className="relative">
                  <span className="text-[10px] tracking-[0.32em] uppercase text-gold/80">{bottles.length} bottles</span>
                  <h3 className="font-display text-3xl lg:text-4xl text-bone-50 mt-3">{col.name}</h3>
                  <p className="text-bone-200/85 mt-2 max-w-md">{col.desc}</p>
                </div>
                <div className="relative flex items-end justify-between gap-4">
                  <div className="flex items-end gap-3">
                    {bottles.map((b, i) => (
                      <div key={b.id} className={i === 1 ? '-translate-y-3' : ''}>
                        <Bottle product={b} size="sm" />
                      </div>
                    ))}
                  </div>
                  <span className="inline-flex items-center gap-2 text-bone-100 group-hover:text-gold transition-colors text-sm tracking-[0.18em] uppercase self-end">
                    Explore <ArrowRight className="w-4 h-4" />
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </section>
    </div>
  );
}
